import { useExternalSystems } from 'src/hooks/useExternalSystems/useExternalSystems';

const ASSURE_NAME_FRAGMENT = 'assure';

export const useTimetableRangesEnabled = () => {
  const { data: externalSystems, isLoading } = useExternalSystems();

  const isEnabled = (externalSystems ?? []).some((system) => system.name?.toLowerCase().includes(ASSURE_NAME_FRAGMENT));

  return { isEnabled, isLoading };
};
